// extracted by mini-css-extract-plugin
export default {"organ":"index_organ_1sUo-","organBox":"index_organBox_EKach","organPic":"index_organPic_tujiB"};